
export const shouldIncludeInput = (input, edad) => {
    if (input.esAdulto) return edad > 15;
    if (input.esPediatrico) return edad <= 15;
    return true;
};